import { render, staticRenderFns } from "./PurchaseListPage.vue?vue&type=template&id=0904a8ec&scoped=true&"
import script from "./PurchaseListPage.vue?vue&type=script&lang=ts&"
export * from "./PurchaseListPage.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseListPage.vue?vue&type=style&index=0&id=0904a8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904a8ec",
  null
  
)

export default component.exports